var config = {
  dev: {},
  stg: {},
  prod: {
    global: '//api-global-phx.yunxuetang.cn/v2/',
    langSrc: '//picobd.yunxuetang.cn/orgsv2/glbl/default/',
    core: '//api-core-phx.yunxuetang.cn/v2/',
    udp: '//api-udp-phx.yunxuetang.cn/v2/'
  },
  tcstress: {},
  feature: {},
  source: 501
};
export default config;